module.exports = __webpack_public_path__ + "media/human_1.0efa3fa3.mp3";